/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Picker_Add_ChildInputs */

const en_guest_picker_add_child = /** @type {(inputs: Guest_Picker_Add_ChildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add child`)
};

/**
* | output |
* | --- |
* | "Add child" |
*
* @param {Guest_Picker_Add_ChildInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guest_picker_add_child = /** @type {((inputs?: Guest_Picker_Add_ChildInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Picker_Add_ChildInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guest_picker_add_child(inputs)
});